export default __webpack_public_path__ + "static/xlab-4113ccd38a8ff1b0c24c381282ff923a.svg";